export const SLICE = {
  BASE_AUTH: "feature/base-auth",
  SIGN_IN: "feature/sign-in",
  FORGOT_PASSWORD: "feature/forgot-password",
  RESET_PASSWORD: "feature/reset-password",
  NOTIFICATION: "feature/notification",
  VERIFY_CALLBACK: "feature/verify-callback",
  DASHBOARD: "feature/dashboard",
  SUMMARY: "feature/summary",
  GLOBAL: "features/global",
};
